import { createSlice, current } from "@reduxjs/toolkit";
const CartSlice = createSlice({
    name: "cart",
    initialState : {
        cart : [],
        num : 50
    },
    reducers: {
        addtoCart : (state,action) =>{
            state.cart.push(JSON.parse(JSON.stringify(action.payload)))
            console.log(current(state.cart))
            console.log(JSON.parse(JSON.stringify(state.cart)))
            //console.log(state.cart[0].img)
            console.log(state.num)
            
        },
        removefromcart : (state,action)=> {
            state.cart = state.cart.filter(x=> x.num !== action.payload.id)
        }
        

    }
})
export default CartSlice;